// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.check-email-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  background: linear-gradient(135deg, #dce9fa 0%, #eef3fb 50%, #f0f4fd 100%);
  font-family: 'Inter', sans-serif;
}

.check-email-container {
  background-color: white;
  border-radius: 16px;
  padding: 40px 36px 32px;
  box-shadow: 0 8px 32px rgba(59, 130, 246, 0.1), 0 1.5px 6px rgba(0, 0, 0, 0.06);
  width: 420px;
  max-width: calc(100vw - 32px);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.check-email-logo {
  width: 160px;
  margin-bottom: 24px;
}

.check-email-illustration {
  width: 200px;
  max-width: 100%;
  height: auto;
  margin-bottom: 28px;
}

.check-email-title {
  color: #1a1a2e;
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 16px;
  line-height: 1.2;
}

.check-email-message {
  color: #3d4454;
  font-size: 15px;
  line-height: 1.6;
  margin: 0 0 28px;
  max-width: 340px;
}

.check-email-message strong {
  color: #1a1a2e;
  font-weight: 700;
  word-break: break-all;
}

.check-email-divider {
  width: 100%;
  border: none;
  border-top: 1px solid #e8ecf1;
  margin: 0 0 20px;
}

.check-email-hint {
  color: #6b7280;
  font-size: 14px;
  line-height: 1.5;
  margin: 0 0 24px;
}

.check-email-back-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background-color: #fff;
  color: #0075ff;
  font-size: 15px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;
  box-sizing: border-box;
}

.check-email-back-button:hover {
  background-color: #f8fafc;
  border-color: #0075ff;
}
`, "",{"version":3,"sources":["webpack://./src/pages/auth/check-email/check-email.page.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,0EAA0E;EAC1E,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,+EAA+E;EAC/E,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gEAAgE;EAChE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB","sourcesContent":[".check-email-page {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  width: 100%;\n  background: linear-gradient(135deg, #dce9fa 0%, #eef3fb 50%, #f0f4fd 100%);\n  font-family: 'Inter', sans-serif;\n}\n\n.check-email-container {\n  background-color: white;\n  border-radius: 16px;\n  padding: 40px 36px 32px;\n  box-shadow: 0 8px 32px rgba(59, 130, 246, 0.1), 0 1.5px 6px rgba(0, 0, 0, 0.06);\n  width: 420px;\n  max-width: calc(100vw - 32px);\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.check-email-logo {\n  width: 160px;\n  margin-bottom: 24px;\n}\n\n.check-email-illustration {\n  width: 200px;\n  max-width: 100%;\n  height: auto;\n  margin-bottom: 28px;\n}\n\n.check-email-title {\n  color: #1a1a2e;\n  font-size: 28px;\n  font-weight: 700;\n  margin: 0 0 16px;\n  line-height: 1.2;\n}\n\n.check-email-message {\n  color: #3d4454;\n  font-size: 15px;\n  line-height: 1.6;\n  margin: 0 0 28px;\n  max-width: 340px;\n}\n\n.check-email-message strong {\n  color: #1a1a2e;\n  font-weight: 700;\n  word-break: break-all;\n}\n\n.check-email-divider {\n  width: 100%;\n  border: none;\n  border-top: 1px solid #e8ecf1;\n  margin: 0 0 20px;\n}\n\n.check-email-hint {\n  color: #6b7280;\n  font-size: 14px;\n  line-height: 1.5;\n  margin: 0 0 24px;\n}\n\n.check-email-back-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  background-color: #fff;\n  color: #0075ff;\n  font-size: 15px;\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n  box-sizing: border-box;\n}\n\n.check-email-back-button:hover {\n  background-color: #f8fafc;\n  border-color: #0075ff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
